import { FadeUp, SectionHeader } from "./Reveal";
import { TESTIMONIALS } from "../../lib/content";

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="relative py-32 md:py-48 bg-[#eceae4]/70">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <SectionHeader number="04" kicker="Testimonials">
        <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-[#1c1610]">
          <FadeUp>They came to learn. <em className="italic text-[#DB0909]">They stayed to play.</em></FadeUp>
        </h2>
      </SectionHeader>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-12 gap-8">
        {TESTIMONIALS.map((t, i) => (
          <FadeUp
            key={t.name}
            delay={i * 0.1}
            className={`md:col-span-6 ${i % 2 === 1 ? "md:mt-16" : ""}`}
            data-testid={`testimonial-card-${i}`}
          >
            <figure className="h-full border-l-2 border-[#950606]/60 bg-[#fefefc] p-8 md:p-10 hover:border-[#DB0909] transition-colors duration-500">
              <span className="font-display text-6xl text-[#950606]/30 leading-none">"</span>
              <blockquote className="font-display italic text-lg md:text-xl leading-relaxed text-[#1c1610] -mt-4">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                {t.image ? (
                  <img
                    src={t.image}
                    alt={t.name}
                    loading="lazy"
                    className="w-14 h-14 rounded-full object-cover border border-[#1c1610]/20 grayscale hover:grayscale-0 transition-all duration-500 shrink-0"
                  />
                ) : (
                  <span className="w-8 h-px bg-[#950606]" />
                )}
                <div>
                  <p className="font-mono text-xs tracking-[0.2em] uppercase text-[#1c1610]">{t.name}</p>
                  <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-[#4a3e30] mt-1">{t.detail}</p>
                </div>
              </figcaption>
            </figure>
          </FadeUp>
        ))}

        {/* Placeholder for upcoming testimonials */}
        <FadeUp delay={0.2} className="md:col-span-6" data-testid="testimonial-upcoming-placeholder">
          <div className="h-full border border-dashed border-[rgba(28,22,16,0.25)] bg-[#f6efe3]/30 p-8 md:p-10 flex flex-col items-start justify-center gap-3 min-h-[220px]">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#950606]">More on the way</p>
            <p className="font-display italic text-lg text-[#4a3e30]">Three more student stories in the making — tuning up soon.</p>
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
